module.exports = __webpack_public_path__ + "img/collect_icon_04.c996c152.png";